var $, localmed;

$ = window.jQuery;

localmed = require('./base');

require('./plugin');

require('./get-target');

$(document).on('mouseover.column.data-api mouseleave.column.data-api', '[data-toggle="column"], [data-toggle-columns] td, [data-toggle-columns] th', function(event) {
  return $(this).toggleColumn(null, event);
});

$.plugin('toggleColumn', {
  defaults: {
    activeClass: localmed.defaults.activeClass
  },
  init: function() {
    return this.target = this.element.getTarget() || this._getTargetColgroup();
  },
  run: function(event) {
    return this.target.toggleClass(this.options.activeClass, event.type === 'mouseover');
  },
  _getTargetColgroup: function() {
    return this.element.closest('table').find('colgroup').eq(this.element.index());
  }
});
